import { createSlice } from "@reduxjs/toolkit";
import { mergeObjects } from "../utils";
import { VirtualGapsData } from "../components/Timing/PitBoostCorrectedLeaderboard/types";

const initialState = {
  data: {} as VirtualGapsData,
  hilightedParticipant: null as string | null,
  showLoops: true,
};

export const virtualGapsSlice = createSlice({
  name: "virtualGaps",
  initialState,
  reducers: {
    combineVirtualGaps: (state, action) => {
      const copy = JSON.parse(JSON.stringify(action.payload));
      mergeObjects(state.data, copy);
    },
    setHilightedParticipant: (state, action) => {
      state.hilightedParticipant = action.payload;
    },
    setShowLoops: (state, action) => {
      state.showLoops = action.payload;
    },
  },
});

export const { combineVirtualGaps, setHilightedParticipant, setShowLoops } =
  virtualGapsSlice.actions;
export default virtualGapsSlice.reducer;
